module.exports = __webpack_public_path__ + "img/jelly3_thumb.64e837f8.jpg";